// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();

//         this.selectors = {
//           viewer: '[id^="GalleryViewer"]',
//           thumbnails: '[id^="GalleryThumbnails"]',
//           mediaList: '[id^="Slider-Gallery"]',
//           mediaItems: ['.product__media-item'],
//         };

//         this.sliderInstance = false;
//         this.thumbsInstance = false;
//       }

//       connectedCallback() {
//         this.init();
//       }

   

//       init() {
//         this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
//         this.mediaLayout = this.dataset.mediaLayout;
//         this.onlyImage = this.dataset.onlyImage === 'true';
//         this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
//         this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
//         this.enableImageZoom = this.dataset.enableImageZoom === 'true';
//         this.setSliderOptions();

//         const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
//         mql.onchange = this.updateMediaLayout.bind(this);
//         this.updateMediaLayout();

//         if (this.enableImageZoom) {
//           this.initImageZoom();
//         }
//       }

//       setSliderOptions() {
//         const mediaItemGap = parseInt(this.dataset.mediaItemGap);

//         this.sliderOptions = {
//           init: false,
//           slidesPerView: '1',
//           spaceBetween: mediaItemGap,
//           loop: false,
//           grabCursor: true,
//           allowTouchMove: true,
//           autoHeight: false,
//           navigation: {
//             nextEl: this.querySelector('.swiper-button-next'),
//             prevEl: this.querySelector('.swiper-button-prev'),
//           },
//           pagination: {
//             el: this.querySelector('.swiper-pagination'),
//             clickable: true,
//             type: 'fraction',
//           },
//           threshold: 2,
//         };

//         this.thumbsOptions = {
//           slidesPerView: 4,
//           breakpoints: {
//             461: {
//               slidesPerView: 5,
//             },
//           },
//           spaceBetween: mediaItemGap,
//           loop: false,
//           freeMode: true,
//           watchSlidesProgress: true,
//           threshold: 2,
//         };

//         switch (this.mediaLayout) {
//           case 'vertical-carousel':
            
//             this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
//               breakpoints: {
//                 768: {
//                   direction: 'vertical',
//                   slidesPerView: '4',
//                 },
//               },
//             });
//             break;
//           case 'slider-freemode':
//             this.sliderOptions = Object.assign({}, this.sliderOptions, {
//               slidesPerView: 'auto',
//             });
//             break;
//         }
//       }

//       updateMediaLayout() {
//         if (FoxTheme.config.mqlMobile) {
//           this.initSlider();
//         } else {
//           if (this.enableDesktopSlider) {
//             this.initSlider();
//           } else {
//             this.destroySlider();
//           }
//         }
//       }

//       initSlider() {
//         if (typeof this.sliderInstance !== 'object') {
//           if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
//             this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
//             this.thumbsInstance.init();

//             this.sliderOptions.thumbs = {
//               swiper: this.thumbsInstance.slider,
//               autoScrollOffset: 2,
//             };
//           }

//           this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
//             FoxTheme.Swiper.Thumbs,
//           ]);
//           this.sliderInstance.init();

//           this.handleSliderAfterInit();
//           this.handleSlideChange();

//           this.sliderInstance.slider.init();
//         }
//       }

//       destroySlider() {
//         if (typeof this.sliderInstance === 'object') {
//           this.sliderInstance.slider.destroy();
//           this.sliderInstance = false;
//         }
//       }

//       initThumbsSlider() {
//         if (typeof this.thumbsInstance !== 'object') {
//           this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
//           this.thumbsInstance.init();
//         }
//       }

//       initImageZoom() {
//         let dataSource = [];
//         const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
//         if (allMedia) {
//           allMedia.forEach((media) => {
//             switch (media.dataset.mediaType) {
//               case 'model':
//                 dataSource.push({
//                   id: media.dataset.mediaIndex,
//                   html: `<div class="pswp__item--${media.dataset.mediaType}">${
//                     media.querySelector('product-model').outerHTML
//                   }</div>`,
//                   mediaType: media.dataset.mediaType,
//                 });
//                 break;
//               case 'video':
//               case 'external_video':
//                 dataSource.push({
//                   id: media.dataset.mediaIndex,
//                   html: `<div class="pswp__item--${media.dataset.mediaType}">${
//                     media.querySelector('video-element').outerHTML
//                   }</div>`,
//                   mediaType: media.dataset.mediaType,
//                 });
//                 break;
//               case 'image':
//                 dataSource.push({
//                   id: media.dataset.mediaIndex,
//                   src: media.dataset.src,
//                   width: media.dataset.pswpWidth,
//                   height: media.dataset.pswpHeight,
//                   mediaType: media.dataset.mediaType,
//                 });
//                 break;
//             }
//           });
//         }

//         this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
//           dataSource: dataSource,
//           pswpModule: window.FoxTheme.PhotoSwipe,
//           bgOpacity: 1,
//           arrowPrev: false,
//           arrowNext: false,
//           zoom: false,
//           close: false,
//           counter: false,
//           preloader: false,
//         });

//         this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
//           if (this.sliderInstance && this.sliderInstance.slider) {
//             const { slides, activeIndex } = this.sliderInstance.slider;
//             if (slides[activeIndex]) {
//               const el = slides[activeIndex].querySelector('img');
//               if (el) {
//                 return el;
//               }
//             }
//           }

//           return thumbEl;
//         });

//         this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
//           if (this.sliderInstance && this.sliderInstance.slider) {
//             const { slides, activeIndex } = this.sliderInstance.slider;
//             if (slides[activeIndex]) {
//               const el = slides[activeIndex].querySelector('img');
//               if (el) {
//                 return el.src;
//               }
//             }
//           }

//           return placeholderSrc;
//         });

//         this.lightbox.on('change', () => {
//           window.pauseAllMedia(this);
//           if (this.sliderInstance && this.sliderInstance.slider) {
//             const { currIndex } = this.lightbox.pswp;
//             if (this.sliderInstance.slider.realIndex !== currIndex) {
//               this.sliderInstance.slider.slideToLoop(currIndex, 100, false);
//             }
//           }
//         });

//         this.lightbox.on('pointerDown', (e) => {
//           if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
//             e.preventDefault();
//           }
//         });

//         this.lightbox.on('uiRegister', () => {
//           if (!this.onlyImage) {
//             this.lightbox.pswp.ui.registerElement({
//               name: 'next',
//               ariaLabel: 'Next slide',
//               order: 3,
//               isButton: true,
//               html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
//               onClick: (event, el) => {
//                 this.lightbox.pswp.next();
//               },
//             });
//             this.lightbox.pswp.ui.registerElement({
//               name: 'prev',
//               ariaLabel: 'Previous slide',
//               order: 1,
//               isButton: true,
//               html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
//               onClick: (event, el) => {
//                 this.lightbox.pswp.prev();
//               },
//             });
//           }
//           this.lightbox.pswp.ui.registerElement({
//             name: 'close-zoom',
//             ariaLabel: 'Close zoom image',
//             order: 2,
//             isButton: true,
//             html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
//             onClick: (event, el) => {
//               this.lightbox.pswp.close();
//             },
//           });
//         });

//         this.lightbox.init();

//         FoxTheme.utils.addEventDelegate({
//           selector: '.js-photoswipe--zoom',
//           context: this,
//           handler: (e, media) => {
//             if (media.dataset.mediaType === 'image') {
//               const index = Number(media.dataset.mediaIndex) || 0;
//               this.lightbox.loadAndOpen(index);
//             }
//           },
//         });
//       }

//       handleSliderAfterInit() {
//         this.sliderInstance.slider.on('afterInit', (swiper) => {
//           const { slides, activeIndex } = swiper;

//           if (slides[activeIndex]) {
//             const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
//             this.toggleSliderDraggableState(!isModelMediaType);
//           }
//         });
//       }

//       handleSlideChange() {
//         this.sliderInstance.slider.on('realIndexChange', (swiper) => {
//           const { slides, activeIndex, thumbs } = swiper;

//           if (thumbs.swiper) {
//             thumbs.swiper.slideTo(activeIndex);
//           }

//           if (slides[activeIndex]) {
//             this.playActiveMedia(slides[activeIndex]);

//             const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
//             this.toggleSliderDraggableState(!isModelMediaType);
//           }
//         });
//       }

//       toggleSliderDraggableState(isDraggable) {
//         if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
//           this.sliderInstance.slider.allowTouchMove = isDraggable;
//         }
//       }

//       playActiveMedia(selected) {
//         const deferredMedia = selected.querySelector('product-model');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       // setActiveMedia(variant) {
//       //   console.log("testing----slider--fucntion--working")
//       //   if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;

//       //   if (this.sliderInstance.slider) {
//       //     let slideIndex = variant.featured_media.position - 1 || 0;
//       //     if (slideIndex<1) {
//       //       slideIndex=1;
//       //     }
//       //     var index = $('.product__thumbs-item.swiper-slide').index($(`.product__thumbs-item.swiper-slide[data-media-position="${slideIndex}"]`).first());

//       //     this.sliderInstance.slider.slideToLoop(index);
//       //     if ($(".product.product--vertical-carousel").length) {
            
//       //       this.sliderInstance.slider.once('transitionEnd', () => {
//       //         setTimeout(() => {
//       //         // Fix transform starts
//       //         try {
                
//       //           const el = document.querySelector("[id^=Slider-Thumbnails]");
                
//       //           // Get current transform
//       //           const transform = el.style.transform || getComputedStyle(el).transform;
                
//       //           // Extract the Y value
//       //           const match = transform.match(/translate3d\(\s*[^,]+,\s*([-\d.]+)px,/);
//       //           let product = document.querySelector("div.product [id^=MediaGallery]").getBoundingClientRect();
//       //           let active_slide = document.querySelector(".product__media-gallery-thumbails .swiper-slide.swiper-slide-thumb-active .product__thumbs-container").getBoundingClientRect();
//       //           let diff = product.top - active_slide.top ;
//       //           let currentY = parseFloat(match[1]);
//       //           let newY = currentY + diff; 
//       //           console.log("Difff=",diff)
//       //           console.log("currentY--",currentY)
//       //           console.log("newY--",newY)
//       //           $("[id^=Slider-Thumbnails]").css({
//       //           transition: "transform 0.4s ease",
//       //           transform: `translate3d(0px, ${newY}px, 0px)`
//       //         });
              
//       //         // el.style.transform = `translate3d(0px, ${newY}px, 0px)`;
//       //         // Fix transform ends
//       //       } catch (error) {
//       //         console.log("Slide error---",error);
              
//       //       }
//       //       }, 10);
//       //     });
//       //   }
//       //   } else {
//       //     this.sortMediaItems(variant);
//       //   }
//       // }

//       sortMediaItems(variant) {
//         let newMedias = this.elements.mediaItems;

//         // Reset ordering.
//         newMedias.sort(function (a, b) {
//           return a.dataset.mediaIndex - b.dataset.mediaIndex;
//         });

//         newMedias.some((media, index) => {
//           if (media.dataset.mediaId == variant.featured_media.id) {
//             const [element] = newMedias.splice(index, 1);
//             newMedias.unshift(element);
//             return true;
//           }
//         });

//         this.elements.mediaList.innerHTML = '';
//         newMedias.forEach((media) => {
//           this.elements.mediaList.appendChild(media);
//         });

//         if (!FoxTheme.config.mqlMobile) {
//           const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
//           if (selectedMedia) {
//             window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
//           }
//         }
//       }
//     }
//   );
// }


if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        this.init();
      }

   

      init() {
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.setSliderOptions();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();

        if (this.enableImageZoom) {
          this.initImageZoom();
        }
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);

        this.sliderOptions = {
          init: false,
          slidesPerView: '1',
          spaceBetween: mediaItemGap,
          // loop: false,
          loop: false,
           rewind: true, 

          grabCursor: true,
          allowTouchMove: true,
          autoHeight: false,
          setWrapperSize:true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
            },
          },
          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: this.querySelector('.thumbs-swiper-button-next'),
            prevEl: this.querySelector('.thumbs-swiper-button-prev'),
          },
          threshold: 2,
        };


        switch (this.mediaLayout) {
          case 'vertical-carousel':
            
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              breakpoints: {
                768: {
                  direction: 'vertical',
                  slidesPerView: '4',
                },
              },
            });
            break;
          case 'slider-freemode':
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              slidesPerView: 'auto',
            });
            break;
        }
      }

      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }
 

      initSlider() {
      if (typeof this.sliderInstance !== 'object') {
        if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();

          this.sliderOptions.thumbs = {
            swiper: this.thumbsInstance.slider,
            autoScrollOffset: 0,
          };
        }

    this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
      FoxTheme.Swiper.Thumbs,
    ]);
    this.sliderInstance.init();

    this.handleSliderAfterInit();
    this.handleSlideChange();

    this.sliderInstance.slider.init();

    // NEW: thumbs arrow click se main slider ko sync karo
    this.handleThumbsSlideChange();
     this.handleSmoothRewind(); 
    this.handleInfiniteNavigation();
  }
}

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object') {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

      initImageZoom() {
        let dataSource = [];
        const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
        if (allMedia) {
          allMedia.forEach((media) => {
            switch (media.dataset.mediaType) {
              case 'model':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('product-model').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'video':
              case 'external_video':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('video-element').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'image':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
        });

        this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el.src;
              }
            }
          }

          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { currIndex } = this.lightbox.pswp;
            if (this.sliderInstance.slider.realIndex !== currIndex) {
              this.sliderInstance.slider.slideToLoop(currIndex, 100, false);
            }
          }
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        FoxTheme.utils.addEventDelegate({
          selector: '.js-photoswipe--zoom',
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === 'image') {
              const index = Number(media.dataset.mediaIndex) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

       

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          // Only update thumbs if out of sync to prevent stutter loops
          if (thumbs && thumbs.swiper && thumbs.swiper.activeIndex !== activeIndex) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      // handleThumbsSlideChange() {
      //   if (this.thumbsInstance && this.thumbsInstance.slider) {
      //     this.thumbsInstance.slider.on('tap', (swiper) => {
      //       const clickedIndex = swiper.clickedIndex;
      //       if (
      //         this.sliderInstance &&
      //         this.sliderInstance.slider &&
      //         typeof clickedIndex !== 'undefined' &&
      //         this.sliderInstance.slider.activeIndex !== clickedIndex
      //       ) {
      //         this.sliderInstance.slider.slideTo(clickedIndex);
      //       }
      //     });
      //   }
      // }

      handleThumbsSlideChange() {
        if (this.thumbsInstance && this.thumbsInstance.slider) {
          // Direct click/tap on a thumbnail
          this.thumbsInstance.slider.on('tap', (swiper) => {
            const clickedIndex = swiper.clickedIndex;
            if (
              this.sliderInstance &&
              this.sliderInstance.slider &&
              typeof clickedIndex !== 'undefined' &&
              this.sliderInstance.slider.activeIndex !== clickedIndex
            ) {
              this.sliderInstance.slider.slideTo(clickedIndex);
            }
          });

          // Prev/Next arrow buttons (thumbs-swiper-button-prev / next)
          this.thumbsInstance.slider.on('slideChange', (swiper) => {
            const activeIndex = swiper.activeIndex;
            if (
              this.sliderInstance &&
              this.sliderInstance.slider &&
              typeof activeIndex !== 'undefined' &&
              this.sliderInstance.slider.activeIndex !== activeIndex
            ) {
              this.sliderInstance.slider.slideTo(activeIndex);
            }
          });
        }
      }


      //   handleSmoothRewind() {
      //   const swiper = this.sliderInstance.slider;
      //   const originalSlideTo = swiper.slideTo.bind(swiper);

      //   swiper.slideTo = (index, speed, runCallbacks, internal) => {
      //     const lastIndex = swiper.slides.length - 1;
      //     const current = swiper.activeIndex;

      //     // Rewind wraparound detect karo: last->first ya first->last
      //     const isWrapForward = current === lastIndex && index === 0;
      //     const isWrapBackward = current === 0 && index === lastIndex;

      //     // Sirf wraparound ke liye speed 0 (instant snap), baaki normal speed
      //     const finalSpeed = (isWrapForward || isWrapBackward) ? 0 : speed;

      //     return originalSlideTo(index, finalSpeed, runCallbacks, internal);
      //   };
      // }
        

      // handleSmoothRewind() {
      //   const swiper = this.sliderInstance.slider;
      //   const originalSlideTo = swiper.slideTo.bind(swiper);
      //   const wrapperEl = swiper.wrapperEl;

      //   swiper.slideTo = (index, speed, runCallbacks, internal) => {
      //     const lastIndex = swiper.slides.length - 1;
      //     const current = swiper.activeIndex;

      //     const isWrapForward = current === lastIndex && index === 0;
      //     const isWrapBackward = current === 0 && index === lastIndex;

      //     if ((isWrapForward || isWrapBackward) && wrapperEl) {
      //       // Step 1: Fade out
      //       wrapperEl.style.transition = 'opacity 180ms ease';
      //       wrapperEl.style.opacity = '0';

      //       setTimeout(() => {
      //         // Step 2: Fade poori tarah hone ke baad, bina animation ke slide swap karo
      //         originalSlideTo(index, 0, runCallbacks, internal);

      //         // Step 3: Fade back in
      //         requestAnimationFrame(() => {
      //           wrapperEl.style.opacity = '1';
      //         });

      //         setTimeout(() => {
      //           wrapperEl.style.transition = '';
      //         }, 200);
      //       }, 180);

      //       return swiper;
      //     }

      //     return originalSlideTo(index, speed, runCallbacks, internal);
      //   };
      // }


         handleSmoothRewind() {
        const swiper = this.sliderInstance.slider;
        const originalSlideTo = swiper.slideTo.bind(swiper);

        swiper.slideTo = (index, speed, runCallbacks, internal) => {
          const lastIndex = swiper.slides.length - 1;
          const current = swiper.activeIndex;

          // Rewind wraparound detect karo: last->first ya first->last
          const isWrapForward = current === lastIndex && index === 0;
          const isWrapBackward = current === 0 && index === lastIndex;

          
          const finalSpeed = (isWrapForward || isWrapBackward) ? 0 : speed;

          return originalSlideTo(index, finalSpeed, runCallbacks, internal);
        };
      }
            
         handleInfiniteNavigation() {
  const swiper = this.sliderInstance.slider;

  const getVisibleThumbs = () =>
    Array.from(document.querySelectorAll('.product__thumbs-item')).filter(
      (t) => t.style.display !== 'none' && !t.classList.contains('swiper-slide-duplicate')
    );

  if (swiper.params.navigation) {
    swiper.params.navigation.disabledClass = 'swiper-button-disabled-off';
  }

  const clearDisabledState = () => {
    const { nextEl, prevEl } = swiper.navigation || {};
    if (nextEl) nextEl.removeAttribute('aria-disabled');
    if (prevEl) prevEl.removeAttribute('aria-disabled');
  };

  swiper.on('slideChange', clearDisabledState);
  swiper.on('afterInit', clearDisabledState);
  clearDisabledState();

  const originalSlideNext = swiper.slideNext.bind(swiper);
  const originalSlidePrev = swiper.slidePrev.bind(swiper);

  swiper.slideNext = (speed, runCallbacks) => {
    if (swiper.isEnd) {
      const thumbs = getVisibleThumbs();
      const firstThumb = thumbs[0];
      if (firstThumb) firstThumb.click();
    } else {
      originalSlideNext(speed, runCallbacks);
    }
  };

  swiper.slidePrev = (speed, runCallbacks) => {
    if (swiper.isBeginning) {
      const thumbs = getVisibleThumbs();
      const lastThumb = thumbs[thumbs.length - 1];
      if (lastThumb)
        {lastThumb.click();
           setTimeout(()=>{ lastThumb.click();},50)
    }
      if (lastThumb) console.log("lst click----")
    } else {
      originalSlidePrev(speed, runCallbacks);
    }
  };
}


      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = '';
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        if (!FoxTheme.config.mqlMobile) {
          const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
          }
        }
      }
    }
  );
}